import { render, staticRenderFns } from "./read_sentences.vue?vue&type=template&id=3513797a&scoped=true"
import script from "./read_sentences.vue?vue&type=script&lang=js"
export * from "./read_sentences.vue?vue&type=script&lang=js"
import style0 from "./read_sentences.vue?vue&type=style&index=0&id=3513797a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513797a",
  null
  
)

export default component.exports